import { tss } from '@/shared/styles/tss'

export const useStyles = tss.withName('TestPage').create(() => ({
  root: {
    width: '100%',
  },
  version: {
    color: '#FAFAFA',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-end',
    borderRadius: '5px',
    padding: '5px 10px ',
    background: 'rgba(193,164, 062, 0.25)',
    position: 'fixed',
    bottom: '4vh',
    right: '16vh',
    zIndex: 99,
    p: {
      margin: 0,
    },
  },
}))
